function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import vuedraggable from 'vuedraggable';
import linkaddress from '@/components/linkaddress';
import OperationFloorModal from '@/components/HotpotModal';
import modalSure from '@/libs/modal-sure';
export default {
  name: 'c_hot_menu',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    index: {
      type: null
    },
    isRub: {
      type: Boolean,
      default: false
    }
  },
  components: {
    draggable: vuedraggable,
    linkaddress: linkaddress,
    OperationFloorModal: OperationFloorModal
  },
  data: function data() {
    return {
      setHotVisible: false,
      defaults: {},
      configData: {},
      gridBtn: {
        xl: 4,
        lg: 8,
        md: 8,
        sm: 8,
        xs: 8
      },
      gridPic: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12
      },
      activeIndex: 0,
      indexLast: 0,
      lastObj: {},
      linkList: [],
      imgAreaData: [],
      //热区数据
      changeCreated: true
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.defaults = _this2.configObj;
      _this2.configData = _this2.configObj[_this2.configNme];
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
      },
      deep: true
    }
  },
  methods: {
    //取消或确认
    dialogChange: function dialogChange(type, areaData) {
      if (type) {
        this.footerClick(areaData);
      } else {
        this.close();
      }
    },
    close: function close() {
      this.$refs.hotpot.areaData = _toConsumableArray(this.configObj.checkoutConfig.hotspot);
      this.setHotVisible = false;
    },
    footerClick: function footerClick(areaData) {
      this.setHotVisible = false;
      this.configObj.checkoutConfig.hotspot = areaData;
    },
    //模态框关闭
    handleClose: function handleClose(done) {
      var _this3 = this;
      this.$modalSure('确认关闭？').then(function (_) {
        _this3.$refs.hotpot.areaData = _toConsumableArray(_this3.$refs.hotpot.imgAreaData);
        done();
      }).catch(function (_) {});
    },
    //设置热区
    setHot: function setHot() {
      if (this.configData.list[0].img !== '') {
        this.setHotVisible = true;
      } else {
        this.$message({
          message: '请先选择图片',
          type: 'warning'
        });
      }
    },
    //状态切换
    onchangeIsShow: function onchangeIsShow(e) {
      this.configData.list[this.activeIndex].status = e;
    },
    linkUrl: function linkUrl(e) {
      this.configData.list[this.activeIndex].info[this.indexLast].value = e;
      if (this.defaults.name == 'homeHotspot') {
        this.defaults.picStyle.picList[this.defaults.picStyle.tabVal].link = e;
      }
    },
    getLink: function getLink(index, key, item) {
      this.indexLast = item.length - 1;
      if (key != item.length - 1) {
        return;
      }
      this.activeIndex = index;
      this.$refs.linkaddres.dialogVisible = true;
    },
    addBox: function addBox() {
      if (this.configData.list.length == 0) {
        this.lastObj.img = '';
        this.lastObj.info[0].value = '';
        this.lastObj.info[1].value = '';
        this.configData.list.push(this.lastObj);
      } else {
        var obj = JSON.parse(JSON.stringify(this.configData.list[this.configData.list.length - 1]));
        obj.img = '';
        obj.info[0].value = '';
        obj.info[1].value = '';
        this.configData.list.push(obj);
      }
    },
    // 点击图文封面
    modalPicTap: function modalPicTap(item, index) {
      var _this = this;
      _this.$modalUpload(function (img) {
        if (!img) return;
        item.img = img[0].sattDir;
        if (_this.isRub) _this.getPic(img[0].sattDir);
      }, false, 'diy');
    },
    // 获取图片信息
    getPic: function getPic(pc) {
      var _this4 = this;
      if (this.$refs.hotpot) {
        this.changeCreated = false;
        this.configObj.checkoutConfig.hotspot = [];
        this.$refs.hotpot.imgAreaData = [];
        this.$refs.hotpot.areaData = [];
        this.$refs.hotpot.nowNum = 0;
        this.changeCreated = true;
      }
      this.$nextTick(function () {
        _this4.configData.list[_this4.activeIndex].img = pc;
        var data = _this4.defaults.menuConfig;
        if (data && data.isCube) {
          _this4.defaults.picStyle.picList.splice(_this4.defaults.picStyle.tabVal, 1, {
            image: pc,
            link: data.list[0].info[0].value
          });
        }
      });
    },
    onBlur: function onBlur() {
      var data = this.defaults.menuConfig;
      this.defaults.picStyle.picList[this.defaults.picStyle.tabVal].link = data.list[0].info[0].value;
    },
    // 删除
    bindDelete: function bindDelete(item, index) {
      if (this.configData.list.length == 1) {
        this.lastObj = this.configData.list[0];
      }
      this.configData.list.splice(index, 1);
    }
  }
};